<div (keyup.enter)="confirm()" class="content">
  <label class="tokenLabel" i18n>User does not exist. </label>
</div>
<div>
  <button class="confirmButton" mat-button (click)="confirm()" i18n>
    Back
  </button>
</div>
